import { render, staticRenderFns } from "./SettingsIndexCreate.vue?vue&type=template&id=49799baa&"
import script from "./SettingsIndexCreate.vue?vue&type=script&lang=js&"
export * from "./SettingsIndexCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports